import { useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import { AtomSelectedRace } from "../../../store/races/races.store";
import NoRaceData from "../../shared/errors/noRaceData.error";
import ShimmerLoader from "../../shared/loaders/shimmerLoader.loader";
import RaceTripsComponent from "../raceTrips/raceTrips.component";
import ResultedRaceComponent from "../resultedRace/resultedRace.component";
import RaceFooters from "./RaceFooters/raceFooters.footer";
import RaceMetaData from "./raceMetaData/raceMetaData.component";
import RaceNumbers from "./raceNumbers/raceNumbers.component";
import styles from "./selectedRace.module.scss";
import SelectedRaceStatus from "./selectedRaceStatus/selectedRaceStatus.component";
import TrackSelector from "./TrackSelector/trackSelector.component";
import ElevatedButton from "../../ui/buttons/elevated.button";
import { FiPlayCircle } from "react-icons/fi";
import { AtomAuthUser } from "../../../store/auth/auth.store";
import { API, getApiHeader } from "../../../common/configs/api.config";
import {
  AtomVideoErrors as AtomVideoError,
  AtomVideoSocket,
} from "../../../store/videoSocket.store";
import { showToast } from "../../../common/helpers/debugging.helper";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { AtomVideoTracks } from "../../../store/global/global.store";
import VideoWrapper from "../../shared/videoComponent/video.wrapper";
import Loader from "../../elements/loader/loader.element";
import { SyncLoader } from "react-spinners";

const SelectedRaceComponent = () => {
  const race = useRecoilValue(AtomSelectedRace);
  const user = useRecoilValue(AtomAuthUser);
  const setVideoSocket = useSetRecoilState(AtomVideoSocket);
  const setVideoError = useSetRecoilState(AtomVideoError);
  const videoTrack = useRecoilValue(AtomVideoTracks);
  const param = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setVideoSocket(null);
  }, [param]);
  if (race === undefined) return <ShimmerLoader />;
  if (race === null) return <NoRaceData />;

  const onVideoPlay = () => {
    if (race?.raceKey && user) {
      const { pzoneCode } = race.raceKey;
      const headers = getApiHeader(user);
      setLoading(true);
      API.get(`/racing/ws/${pzoneCode}`, {
        headers,
      })
        .then((res) => {
          if (res.data) {
            setVideoSocket(res.data);
          } else {
            // TODO: Change Language
            setVideoError("Stream not found!");
            setVideoSocket(null);
            showToast("Stream not found!", "error");
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          showToast(err, "error");
        });
    }
  };

  return (
    <div className={styles.selectedRaceWrapper}>
      {loading && (
        <div className={styles.fixedLoader}>
          <SyncLoader
            color={"#FFFFFF"}
            speedMultiplier={0.75}
            loading
            size={15}
          />
        </div>
      )}
      <Header className={styles.selectedRaceHeader}>
        <div className={styles.leftSideChild}>
          <TrackSelector />
          {videoTrack.includes(race?.raceKey?.pzoneCode) && (
            <ElevatedButton className={styles.playButton} onClick={onVideoPlay}>
              <FiPlayCircle style={{ color: "white" }} size={20} />
            </ElevatedButton>
          )}
        </div>
        <div>
          <SelectedRaceStatus race={race} />
        </div>
      </Header>
      <RaceMetaData race={race} />
      <RaceNumbers />
      <VideoWrapper hide={window.innerWidth > 768} />
      <ResultedRaceComponent />
      <RaceTripsComponent />
      <RaceFooters />
    </div>
  );
};

export default SelectedRaceComponent;

// * Styled components
const Header = styled.header`
  background: ${(p) => p.theme.bodyContrast};
`;
